import { useSelector } from "react-redux";
import {
  getChartType,
  getDropdownKey,
  get_metric_info_from_identifier
} from "../../Utils/chart_utils";
import { Empty } from "antd";
import { trainingAPI } from "../../api/TrainingAPI";
import { useState, useEffect } from "react";
import { LoadingComponent } from "../Common/LoadingComponent";
import BarChart from '../Charts/BarChart';
import { mapDataForFPTestingHighcharts } from '../../mappers/model/FPTestingBarChartMapper';
import AsymChartExample from "../Charts/AsymChartExample";

export const StatChartV2 = ({
  value,
  metricType,
  startDate,
  endDate,
  playerId,
  stat,
  position,
  colors = [],
  player_group,
  sessions,
  showTitle = true,
  enableDrillDown= false
}) => {
  const { 
    all_metric_types,
    info: { display_name: teamName, metric: teamMetric, acwr_lower_limit: ACWRLowerLimit, acwr_upper_limit: ACWRUpperLimit},
   } = useSelector(({ team }) => team);
  const [metricKey, setMetricKey] = useState("");
  const [statData, setStatData] = useState([]);
  const [loading, setLoading] = useState(false);

  const {metric_id, metric_stat} = get_metric_info_from_identifier(value);

  useEffect(() => {
    setMetricKey(metric_id);
  }, [metric_id]);

  const metric = Object.values(all_metric_types)
    .reduce((acc, curr) => [...acc, ...curr], [])
    .find((metric) => getDropdownKey(metric, "metricId") === metricKey);

  const fetchSingleStatChartData = async (id) => {
    if (id === "-") {return new Promise();}
    switch (metricType) {
      case "forceplate":
        return trainingAPI.getTestingData({
          start_date: startDate,
          end_date: endDate,
          pos_filter: position,
          metric_type: metricType,
          stats: stat,
          metric_id: id,
          player_id: playerId,
          player_group: player_group,
          sessions: sessions
       });
      case "testing":
        return trainingAPI.getTestingData({
          start_date: startDate,
          end_date: endDate,
          pos_filter: position,
          metric_type: metricType,
          stats: stat,
          metric_id: id,
          player_id: playerId,
          player_group: player_group,
          sessions: sessions
      });
      case "nutrition":
        return trainingAPI.getTestingData({
          start_date: startDate,
          end_date: endDate,
          pos_filter: position,
          metric_type: metricType,
          stats: stat,
          metric_id: id,
          player_id: playerId,
          player_group: player_group,
          sessions: sessions
      });
      default:
        return new Promise();
    }
  };

  const fetchStatChartData = async () => {
    if (metricKey === undefined || metricKey === null || !metricKey) {
      setStatData({});
      return;
    }
    setLoading(true);
    try {
      const statChartData = await fetchSingleStatChartData(metricKey);
      
      setStatData(statChartData);
    } catch (e) {
      setStatData({});
    }
    setLoading(false);
  };
  
  useEffect(() => {
    fetchStatChartData();
  }, [metricKey, stat, startDate, endDate, playerId, position, player_group]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        position: "relative",
        marginBottom: 16,
        alignItems: "center",
      }}
    >
      <LoadingComponent loading={loading} title="Loading chart data...">
        {metric === undefined || !statData?.data?.length ? (
          <div
            style={{
              width: 600,
              height: 400,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Empty description="No data in the specified date range" />
          </div>
        ) : getChartType(metric) === "regular" ? (
          <div className="fp-testing-chart">
            <BarChart 
              options={mapDataForFPTestingHighcharts({
                dataIn: statData, 
                metric, 
                singleAxis: metric.metric_type === "forceplate" ? true : false, 
                isForcePlateMetric: metric.metric_type === "forceplate", 
                isTestingMetric: metric.metric_type === "testing" || metric.metric_type === "nutrition",  // temp till we have line charts
                teamColors: colors, 
                teamName, 
                teamMetric,
                stat: stat,
                position,
                playerGroup: player_group,
                session: sessions,
                ACWRLowerLimit,
                ACWRUpperLimit,
                showTitle,
                enableDrillDown,
                selectedPlayerId: playerId
                })
              } 
            />
          </div>
        ) : (
          <div className="fp-testing-chart">
            <AsymChartExample 
              data={statData?.data || []} 
              metric={metric} 
              stat={stat} 
              showTitle={showTitle}
              enableDrillDown={enableDrillDown}
              position={position}
              playerGroup={player_group}
              session={sessions}
              playerId={playerId}
            >
            </AsymChartExample>
          </div>
        )}
      </LoadingComponent>
    </div>
  );
};
